// extracted by mini-css-extract-plugin
export default {"bodyPage":"DynamicPage_bodyPage__xYP2R"};